import FetchPostDataWithAuthNEW from "../services/FetchPostDataWithAuthNEW";

export default async function FechPostSendSmsReservation(club, body) {

  var url = "/sms_api/send_reservation_sms/" + club;
  var data = await FetchPostDataWithAuthNEW(url, body)

  return data;
}